export default "__VITE_ASSET__cab52105__"